import { useAssetKey } from '../contexts';
import { useAssetParentFragment } from '../gql/generated/AssetParent';

export const useAssetTypename = () =>
  useAssetParentFragment({ from: useAssetKey() }).data?.__typename;
